var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.43 23.9517L28.4998 12.8819L39.5749 23.9565L46.0158 17.5155L28.4998 0L10.9895 17.5103L17.4303 23.9513L17.43 23.9517ZM0 28.4998L6.44119 22.0577L12.8819 28.4985L6.44074 34.9397L0 28.4998ZM17.43 33.0486L28.4998 44.1178L39.5746 33.0434L46.019 39.4809L46.0158 39.4844L28.4998 56.9997L10.9895 39.4894L10.9804 39.4803L17.4307 33.048L17.43 33.0486ZM44.1178 28.5026L50.5589 22.0614L56.9997 28.5021L50.5587 34.9433L44.1178 28.5026Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0325 28.4965H35.0353L28.4999 21.9607L23.6693 26.7899L23.1144 27.3451L21.9698 28.4899L21.9607 28.4988L21.9698 28.5081L28.4999 35.0392L35.0357 28.5033L35.0389 28.4997L35.033 28.4965",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/Binance.ea3b3f2ce7364475a7dcf39dff7376b7.svg";
export { ForwardRef as ReactComponent };